import {
  GridOptions,
  SizeColumnsToFitGridStrategy,
} from 'ag-grid-community';

const autoSizeStrategy: SizeColumnsToFitGridStrategy = {
  type: 'fitGridWidth',
};

export const FinanceViewGridOptions: GridOptions = {
  animateRows: true,
  autoSizePadding: 16,
  enableCellTextSelection: true,
  popupParent: document.body,
  suppressAggFuncInHeader: true,
  domLayout: 'autoHeight',
  autoSizeStrategy,
  stopEditingWhenCellsLoseFocus: true
}
